import React, {Component} from "react";
import {connect} from "react-redux";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import {createEvent, editEvent} from "../../actions/eventsActions";

const styles = theme => ({
    modalGrid: {
        padding: theme.spacing(3, 2),
    },
    selectMenu: {
        width: '200px',
    },
});

class EditEventModal extends Component {

    constructor(props) {
        super(props);

        this.state = {name: this.props.event.name}
    }

    render() {
        return (
            <Grid container direction={"column"} className={this.props.classes.modalGrid}>
                <Typography variant={"h4"}>
                    Upravit akci
                </Typography>
                <Divider/>
                <TextField style={{margin: '10px'}}
                           id="outlined-name"
                           label="Jméno akce"
                           value={this.state.name}
                           onChange={e => this.handleChange(e)}
                           margin="normal"
                           variant="outlined"
                           name="name"
                />
                <Button id={"modalButton"} variant="contained" size="medium" color="primary"
                        onClick={e => this.save(e)}>
                    Uložit změny
                </Button>
            </Grid>
        );
    }

    save = (e) => {
        e.preventDefault();

        this.props.dispatch(editEvent(this.props.event.id, this.state.name));
        this.props.handleClose();
    };

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

}


export default connect()(withStyles(styles)(EditEventModal));